import {IFreeToPlayService, IFreeToPlayShowOptions} from "./free-to-play.service.interface";
import {AnimatedIconBaseService} from "../pixi-app/animated-icon-base-service.service";
import {AnimatedIconObservableTarget} from "../pixi-app/animated-icon-base-service.service.interface";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {observable, action, makeObservable} from "mobx";

export class FreeToPlayService extends AnimatedIconBaseService implements IFreeToPlayService {
    constructor(serviceFactory: IServiceFactoryExtended) {
        super(serviceFactory);

        makeObservable(this);

        this.reaction(
            () => this.services.user.isAuthorized,
            (isAuthorized) => {
                if (isAuthorized) {
                    if (this._isEnabled()) {
                        this._checkEligibilityPromise = this._checkEligibility();
                    }
                } else {
                    this._checkEligibilityPromise = Promise.resolve();
                    this._setIsPromotionEligible(false);
                }
            }, {
            fireImmediately: true
        }
        );
    }

    private _checkEligibilityPromise: Promise<void> = Promise.resolve();

    private async _checkEligibility() {
        let shouldShowPromotion = false;
        if (this.services.user.isAuthorized) {
            try {
                shouldShowPromotion = !(await this.services.crm.isPromotionRestricted());
            }
            catch (err) {
                this.services.logger.error('isPromotionRestricted failed', err);
            }
        }

        this._setIsPromotionEligible(shouldShowPromotion);
    }

    waitForEligibility(): Promise<void> {
        return this._checkEligibilityPromise;
    }

    @observable.ref
    private _isPromotionEligible: boolean = false;

    @action.bound
    private _setIsPromotionEligible(isEligible: boolean) {
        this._isPromotionEligible = isEligible;
    }


    get isPromotionEligible(): boolean {
        return this._isPromotionEligible;
    }

    get shouldShowIcon(): boolean {
        return this._shouldShowIcon();
    }

    @observable.ref
    private _isPromotionOpened: boolean = false;

    get isPromotionOpened(): boolean {
        return this._isPromotionOpened;
    }

    get useABTestIcon(): boolean {
        return this.services.abTestingFeatureDataProvider.free2playFloatingIconTest.isEnabled;
    }

    @action.bound
    setIsPromotionOpened(isOpened: boolean) {
        this._isPromotionOpened = isOpened;
    }

    loadFreeToPlayAnimation(options: AnimatedIconObservableTarget) {
        // The icon we test on the AB is a endless loop of wheel animation, therefore we set the interval to 0.
        if (this.useABTestIcon) {
            options.timings.interval = 0;
            options.size.height = 450
        }
        this.loadAnimatedIcon(options);
    }

    private _isEnabled(): boolean {
        return this.services.configuration.servicesConfigs.AppLauncher.apps.CASINO_BONUS_GAME_WIDGET.enabled;
    }

    private _shouldShowIcon(): boolean {
        return this.services.configuration.servicesConfigs.AppLauncher.apps.CASINO_BONUS_GAME_WIDGET.shouldShowIcon;
    }

    async showPromotion(options: IFreeToPlayShowOptions): Promise<void> {
        options.appSpecificParameters = options.appSpecificParameters || {};

        Object.assign(options.appSpecificParameters, {
            publicationID: this.services.configuration.cmsPublicationId,
            //TODO - get dynamic when needed
            templateID: "392012",
            domain: (await this.services.cmsApi).apiOrigin
        });

        await (await this.services.appLauncher).openFreeToPlayBonusGames({
            businessCorrelationID: this.services.tools.getGuid(),
            channel: options.channel,
            appSpecificParameters: options.appSpecificParameters
        });
    }
}
